
import { Component, Vue } from 'vue-property-decorator';
import { isShopifyEmbedded } from '@shopify/app-bridge/utilities';
import { Redirect } from '@shopify/app-bridge/actions';
import { EventBus } from '@/main';
import { reviewRequestService } from '@/services/ReviewRequestService';
import { featureUnlockService } from '@/services/FeatureUnlockService';

const REVIEW_URL = 'https://apps.shopify.com/assisty#modal-show=ReviewListingModal';

@Component
export default class ReviewRequestDialog extends Vue {
  private visible = false;
  private storeId = 0;
  private triggerEvent = '';

  mounted() {
    EventBus.$on('show-review-request-dialog', this.onShow);
  }

  beforeDestroy() {
    EventBus.$off('show-review-request-dialog', this.onShow);
  }

  private onShow(data: { storeId: number; triggerEvent: string }) {
    this.storeId = data.storeId;
    this.triggerEvent = data.triggerEvent;
    this.visible = true;
  }

  private dismiss() {
    this.visible = false;
    this.recordOutcome('dismissed', false);
  }

  private openReview() {
    if (isShopifyEmbedded() && (this.$root as any).app) {
      Redirect.create((this.$root as any).app).dispatch(Redirect.Action.REMOTE, REVIEW_URL);
    } else {
      window.open(REVIEW_URL, '_blank');
    }
    this.visible = false;
    this.recordOutcome('link_opened', true);
  }

  private async recordOutcome(code: string, success: boolean) {
    try {
      await reviewRequestService.recordRequest(
        code,
        success,
        this.triggerEvent,
        { storeId: this.storeId, timestamp: new Date().toISOString() }
      );
    } catch (error) {
      // Non-critical
    }

    // Update FeatureUnlock record with review outcome (Flow C)
    if (this.triggerEvent.startsWith('feature_unlock_')) {
      const featureCode = this.triggerEvent.replace('feature_unlock_', '');
      featureUnlockService.updateReviewStatus(featureCode, true, code).catch(() => {});
    }
  }
}
